import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { thunkFetchLibrary } from '@/redux/actions';
import Loader from '../Loader';
import RenderMediaItem from '../MediaWrapper/RenderMediaItem';

const LibraryMediaPicker = props => {
	const { id, handlePickMedia, event, fetchLibrary, library } = props;
	useEffect(() => {
		grabLibrary('LibraryMediaPicker.useEffect');
	}, [id]);

	const grabLibrary = async from => {
		await fetchLibrary(id, from);
	};

	if (!library.id) return <Loader />;
	const { media } = library;
	return (
		<RenderMediaItem
			media={media.nodes}
			listType="thumbnail"
			event={event}
			handlePickItem={handlePickMedia}
		/>
	);
};

const msp = ({ library }) => ({
	library,
});

const mdp = dispatch => ({
	fetchLibrary: (libraryID, from) => dispatch(thunkFetchLibrary(libraryID, from)),
});

export default connect(msp, mdp)(LibraryMediaPicker);
